import React, { useState } from 'react';
import { Card } from './ui/Card';
import { Input } from './ui/Input';
import { Button } from './ui/Button';
import { useAuth } from '../contexts/AuthContext';
import { useEvent } from '../contexts/EventContext';
interface ProfileProps {
  onBack: () => void;
}
export function Profile({
  onBack
}: ProfileProps) {
  const {
    user,
    updateProfile
  } = useAuth();
  const {
    currentEvent
  } = useEvent();
  const [profile, setProfile] = useState({
    name: user?.name || '',
    email: user?.email || '',
    company: user?.company || '',
    role: user?.role || '',
    bio: user?.bio || ''
  });
  const [isSaving, setIsSaving] = useState(false);
  const handleSave = () => {
    setIsSaving(true);
    updateProfile(profile);
    setTimeout(() => {
      setIsSaving(false);
      onBack();
    }, 500);
  };
  return <div className="pb-24" data-id="element-4017">
      <div className="p-4" data-id="element-4018">
        <Card padding="lg" data-id="element-4019">
          {/* Profile Avatar */}
          <div className="flex justify-center mb-6" data-id="element-4020">
            <div className="w-24 h-24 rounded-full flex items-center justify-center text-white text-3xl font-bold font-gotham" style={{
            backgroundColor: currentEvent.colors.primary
          }} data-id="element-4021">
              {profile.name.split(' ').map(n => n[0]).join('').toUpperCase() || 'U'}
            </div>
          </div>

          <div className="space-y-4" data-id="element-4022">
            <Input label="Full Name" placeholder="John Doe" value={profile.name} onChange={e => setProfile({
            ...profile,
            name: e.target.value
          })} required data-id="element-4023" />

            <Input label="Email" type="email" placeholder="your@email.com" value={profile.email} onChange={e => setProfile({
            ...profile,
            email: e.target.value
          })} required data-id="element-4024" />

            <Input label="Company" placeholder="Your Company" value={profile.company} onChange={e => setProfile({
            ...profile,
            company: e.target.value
          })} data-id="element-4025" />

            <Input label="Role" placeholder="Your Role" value={profile.role} onChange={e => setProfile({
            ...profile,
            role: e.target.value
          })} data-id="element-4026" />

            <div data-id="element-4027">
              <label className="block text-sm font-medium text-gray-700 mb-1 font-gotham" data-id="element-4028">
                Bio
              </label>
              <textarea className="w-full px-4 py-2 border border-gray-300 rounded-lg font-gotham focus:outline-none focus:ring-2 transition-all resize-none" style={{
              '--tw-ring-color': currentEvent.colors.accent
            } as React.CSSProperties} rows={4} placeholder="Tell us about yourself..." value={profile.bio} onChange={e => setProfile({
              ...profile,
              bio: e.target.value
            })} data-id="element-4029" />
            </div>

            <Button variant="primary" fullWidth onClick={handleSave} disabled={isSaving || !profile.name || !profile.email} data-id="element-4030">
              {isSaving ? 'Saving...' : 'Save Changes'}
            </Button>
          </div>
        </Card>
      </div>
    </div>;
}